import type { SlateContent } from '../types';

export const RightDrawerTab = Object.freeze({
  Template: 'template',
  Macro: 'macro',
});

export type RightDrawerTabType = (typeof RightDrawerTab)[keyof typeof RightDrawerTab];

export const RightDrawerAction = Object.freeze({
  Edit: 'edit',
  Clone: 'clone',
});

export type RightDrawerActionType = (typeof RightDrawerAction)[keyof typeof RightDrawerAction];

export type RightDrawerTabItem = {
  tab: RightDrawerTabType;
  label: string;
};

export type OnLoad = (opts: {
  variables: {
    id: string;
  };
}) => Promise<void>;

export type RightDrawerTableCellProps = {
  isVirtualScrolling?: boolean;
};

export type RightDrawerTableItemType = {
  id: string;
  name: string;
  owner?: Nullable<string>;
  action?: RightDrawerActionType;
  lastUsedDateTime?: Nullable<Date>;
};

export type RightDrawerPreviewItemType = {
  content: SlateContent;
  name: string;
  id: string;
  action?: RightDrawerActionType;
};
